import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { UpdateIndividualDTO } from "./type";
import type { OkResponse } from "@typings/api";

export async function updateIndividual(
  individualId: string,
  data: UpdateIndividualDTO,
): Promise<OkResponse> {
  const response = await apiClient.patch<OkResponse>(
    apiPaths.individuals.update(individualId),
    data,
  );
  return response.data;
}
